import { css } from '@emotion/react';

const locationItemSkeletonStyles = {
    container: css({
        width: '100%',
        display: 'flex',
        backgroundColor: '#ffffff',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0',
        gap: '15px',

        ['&:first-of-type']: {
            borderTop: '1px solid #F8FBFF',
        },
        ['&:not(:last-of-type)']: {
            borderBottom: '1px solid #F8FBFF',
        },
        ['&:last-of-type']: {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
    }),

    leftSkeletonsContainer: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
    }),
    topSkeletons: css({
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
    }),
    bottomSkeletons: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    }),
};

export default locationItemSkeletonStyles;
